import { render } from "./sharepointFilesModal.vue?vue&type=template&id=7dedcde3&scoped=true"
import script from "./sharepointFilesModal.vue?vue&type=script&lang=js"
export * from "./sharepointFilesModal.vue?vue&type=script&lang=js"

import "./sharepointFilesModal.vue?vue&type=style&index=0&id=7dedcde3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dedcde3"]])

export default __exports__